import { Card, Form, Row } from 'react-bootstrap'
import { convertDateWithTime } from '../../../../helpers/constants'
import InputDatePicker from '../../../../components/Input/DatePicker/InputDatePicker'
import StyledDetailField from './StyledDetailField'
import { cardStyle, labelDetailStyle } from './DcDetailStyles'

const DcGeneralInfo = ({ detail, setDetail }) => {
  return (
    <Card style={cardStyle}>
      <Row>
        <StyledDetailField
          label="customer"
          value={detail.customer || '-'}
          col={4}
        />
        <StyledDetailField
          label="ERP SJ No."
          value={detail.erp_sj_no || '-'}
          col={4}
          withCopy={true}
        />
        <StyledDetailField
          label="#so"
          value={detail.so || '-'}
          col={4}
          withCopy={true}
        />
        <StyledDetailField
          label="source"
          value={detail.source || '-'}
          col={4}
        />
        <StyledDetailField
          label="delivery type"
          value={detail.delivery_type || '-'}
          col={4}
        />
        <StyledDetailField
          label="driver"
          value={detail.driver || '-'}
          col={4}
        />
        {!detail?.erp_dc_no && (
          <div className="col-12 col-md-4 mb-3">
            <Form.Label style={labelDetailStyle}>
              Delivery Date <sup style={{ color: 'red' }}>*</sup>
            </Form.Label>
            <div className="d-flex flex-column gap-2 fs-6 delivery-date-dc">
              <InputDatePicker
                value={detail?.delivery_date_input}
                onChange={(value) =>
                  setDetail({
                    ...detail,
                    delivery_date_input: value
                  })
                }
                clearIcon
              />
            </div>
          </div>
        )}
        {detail?.erp_dc_no && (
          <>
            <StyledDetailField
              label="delivery date erp"
              value={convertDateWithTime(detail?.delivery_date, 'DD-MM-YYYY')}
              col={3}
            />
            <StyledDetailField
              label="delivery date wms"
              value={convertDateWithTime(
                detail?.actual_delivery_date,
                'DD-MM-YYYY'
              )}
              col={3}
            />
          </>
        )}
        {!detail?.erp_dc_no && (
          <div className="col-12 col-md-4 mb-3">
            <Form.Label style={labelDetailStyle}>
              Posting Time <sup style={{ color: 'red' }}>*</sup>
            </Form.Label>
            <div className="d-flex flex-column gap-2 fs-6 delivery-date-dc">
              <Form.Control
                type="time"
                value={detail?.posting_time || ''}
                step="2"
                onChange={(e) =>
                  setDetail({
                    ...detail,
                    posting_time: e.target.value
                  })
                }
                style={{
                  fontSize: '0.9rem',
                  height: '40px',
                  borderRadius: '8px',
                  border: '1px solid #ced4da'
                }}
              />
            </div>
          </div>
        )}
        {detail?.erp_dc_no && (
          <StyledDetailField
            label="posting time"
            value={detail.posting_time ?? '-'}
            col={3}
          />
        )}
        <StyledDetailField
          label="ERP DC No."
          value={detail.erp_dc_no || '-'}
          col={!detail?.erp_dc_no ? 4 : 3}
          withCopy={true}
        />
      </Row>
    </Card>
  )
}

export default DcGeneralInfo
